export default __webpack_public_path__ + "static/media/verify-email-check.1cd1e082.svg";